// Host detection for the custom store domain (REACT_APP_STORE_HOST, e.g. retail.smrtin.net), which also serves the full app.
const CUSTOM_HOST = window.location.host === process.env.REACT_APP_STORE_HOST;

// Dev/preview only: ?__storehost=1 makes this tab behave like the store host (?__storehost=0 clears). Ignored in production builds.
function devOverride() {
  if (process.env.NODE_ENV === "production") return false;
  const q = new URLSearchParams(window.location.search).get("__storehost");
  if (q === "1") sessionStorage.setItem("__storehost", "1");
  if (q === "0") sessionStorage.removeItem("__storehost");
  return sessionStorage.getItem("__storehost") === "1";
}

export const IS_STORE_HOST = CUSTOM_HOST || devOverride();

// On the custom domain the platform routes /api to the backend, so call it same-origin; elsewhere use the configured backend URL.
export const BACKEND = CUSTOM_HOST ? window.location.origin : process.env.REACT_APP_BACKEND_URL;

// One helper for every link to a public store: /{slug} on the store host, /store/{slug} elsewhere.
export const storePath = (slug) => (IS_STORE_HOST ? `/${slug}` : `/store/${slug}`);
export const DEMO_STORE = "karachi-fresh-mart";

// Must match RESERVED in backend/store.py (checked by backend/tests/test_phase12_host.py): every top-level app route + reserved words.
export const RESERVED = new Set([
  "admin", "api", "app", "contact", "kitchen", "menu", "reservations", "restaurant", "tables", "help", "how-it-works", "import", "inventory", "login", "media", "online-orders", "online-store",
  "pos", "price-tags", "products", "reports", "reseller", "returns", "sales", "settings", "signup", "static", "store", "team", "upgrade", "www",
]);
